"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalizationServiceV1 = exports.PersonalizationType = void 0;
var PersonalizationType;
(function (PersonalizationType) {
    PersonalizationType[PersonalizationType["Behavioural"] = 0] = "Behavioural";
    PersonalizationType[PersonalizationType["Campaign"] = 1] = "Campaign";
})(PersonalizationType || (exports.PersonalizationType = PersonalizationType = {}));
class PersonalizationServiceV1 {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getUseCaseVariantInfo(name, additionalSegments) {
        return {
            variant: "default",
            trackParam: "default",
            iterationId: "no-iteration",
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getUseCaseVariant(name, additionalSegments) {
        return undefined;
    }
    async getVariantInfo(name, featureAppId, personalizationType = PersonalizationType.Behavioural) {
        if (personalizationType === PersonalizationType.Behavioural) {
            return this.getUseCaseVariantInfo(name);
        }
        return this.getCsrefVariantInfo(name, featureAppId);
    }
    getUserSegments() {
        return [];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async getCsrefVariantInfo(name, featureAppId) {
        return {
            variant: "default",
            trackParam: "no-match#none",
        };
    }
}
exports.PersonalizationServiceV1 = PersonalizationServiceV1;
//# sourceMappingURL=index.js.map